import { useRef, useState } from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import { COLORS, Image } from '@musinsa/mds';
import styled from 'styled-components';
import { Swiper as SwiperType } from 'swiper';
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react';

import { MdsTypography } from '@/shared/ui';

type Props = {
  giftNo: number;
  totalIndex: number;
  images: string[];
};
const ImageViewer = ({ giftNo, totalIndex, images = [] }: Props) => {
  const [currIndex, setCurrIndex] = useState(0);
  const swiperRef = useRef<SwiperClass | null>(null);

  const handleSlideChange = (swiperInstance: SwiperType) => {
    setCurrIndex(swiperInstance.realIndex);
  };

  return (
    <div>
      <Swiper
        key={`main-thumbnail-swiper-${totalIndex}`}
        loop={totalIndex > 1}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        onSlideChange={handleSlideChange}
        slidesPerView="auto"
        className="aspect-[5/6]"
      >
        {images.map((img, index) => (
          <SwiperSlide key={`${index}_imageViewer_${giftNo}_${img}`}>
            <S.ImageBox>
              <S.Image mixBlendMultiply src={img} alt={`확대 이미지 ${index + 1}`} />
            </S.ImageBox>
          </SwiperSlide>
        ))}
        <S.IndicatorWrap>
          {totalIndex > 1 && (
            <S.Indicator>
              <MdsTypography variant="body13pxReg" color="black">
                {currIndex + 1}/{totalIndex}
              </MdsTypography>
            </S.Indicator>
          )}
        </S.IndicatorWrap>
      </Swiper>
    </div>
  );
};

export default ImageViewer;

const S = {
  IndicatorWrap: styled.div`
    position: absolute;
    bottom: 16px;
    right: 16px;
    display: flex;
    align-items: center;
    z-index: 10;
  `,
  ImageBox: styled.div`
    background-color: ${COLORS.gray[100]};
    display: flex;
  `,
  Image: styled(Image)``,
  Indicator: styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 7px;
    height: 24px;
    background-color: rgba(0, 0, 0, 0.2);
    color: ${COLORS.white};
    border-radius: 4px;
  `,
};
